// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__zZ2rX","validationTips":"StatementDescriptor_validationTips__1j81c"};